const app: Record<string, string> = {
  name: 'Istation - Just In Time',
  commit: '4c6113a',
  buildDate: '2024-10-22T14:45:49.951Z',
  branch: 'dev',
};

export {
  app,
};
